module.exports = "/_next/static/images/video_id_7186443111818890542-dc66d8189e63f18c859f95eaf3707abe.jpg";